var map = {
	"./floating-indentation.svg": "47cd",
	"./horizontal-spacing.svg": "e135",
	"./inline-spacing.svg": "318b",
	"./left-indentation.svg": "2786",
	"./right-indentation.svg": "0089"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6135";